import { AsYouType, parsePhoneNumber as parseToPhoneNumber } from 'libphonenumber-js';

const formatCurrency = (num) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });
  return Number.isFinite(num) ? formatter.format(num) : null;
};

const formatPercentage = (num) => {
  return num && Number.isFinite(num) ? `${num}%` : '0%';
};

const lowercaseFirstChar = (name) => {
  return name.charAt(0).toLowerCase() + name.slice(1);
};

const formatPhoneNumberField = (v) => {
  return new AsYouType('US').input(v);
};

const parsePhoneNumber = v => {
  const phoneNumber = parseToPhoneNumber(v, 'US');
  return phoneNumber?.number || undefined;
};

export { formatCurrency, formatPercentage, lowercaseFirstChar, formatPhoneNumberField, parsePhoneNumber };
